import * as React from 'react'

import { Alert, Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import SelectField from 'modules/core/components/SelectField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { ActivatePayload } from 'modules/app_store/lib/SubscriptionAddonInstaller'

interface Props {
  onSuccess: (payload?: ActivatePayload | null | undefined) => Promise<boolean>
  onClose: () => void
}

const ActivateDeskyInstallModal = ({ onSuccess, onClose }: Props) => {
  const choiceValueOne = '1'
  const choiceValueTwo = '2'
  const [inputApiKey, setInputApiKey] = React.useState<string>('')
  const [selectedOption, setselectedOption] = React.useState<string>(choiceValueTwo)
  const [inputApiKeyVisible, setInputApiKeyVisible] = React.useState<boolean>(true)

  const choiceOptions = [
    {
      value: choiceValueTwo,
      label: i18n.t('app_store_v2.app_integrations.desky.install_modal.select.options.option_2'),
    },
    {
      value: choiceValueOne,
      label: i18n.t('app_store_v2.app_integrations.desky.install_modal.select.options.option_1'),
    },
  ]

  const onSubmit = () => {
    if (!inputApiKeyVisible || (inputApiKeyVisible && inputApiKey !== '')) {
      onSuccess({
        desky_organization_api_key: inputApiKey,
      })
      onClose()
    }
  }

  return (
    <Modal
      illustration="sync"
      title={i18n.t('app_store_v2.app_integrations.desky.install_modal.title')}
      description={i18n.t('app_store_v2.app_integrations.desky.install_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>
            {i18n.t('app_store_v2.app_integrations.desky.install_modal.submit')}
          </Button>
        </>
      }
    >
      <Box gap="s24">
        <SelectField
          onChange={(value) => {
            setselectedOption(value)
            setInputApiKeyVisible(value === choiceValueTwo)
          }}
          options={choiceOptions}
        />

        {inputApiKeyVisible && (
          <TextField
            label={i18n.t('app_store_v2.app_integrations.desky.install_modal.textfield.label')}
            mandatory={inputApiKeyVisible}
            onChange={setInputApiKey}
          />
        )}

        <Alert color="warning">
          <Box alignItems="flexStart" flexDirection="row" gap="s4">
            <Text.Normal>
              {selectedOption === choiceValueOne && (
                <>
                  <b>
                    {i18n.t(
                      `app_store_v2.app_integrations.desky.install_modal.alert.option_1.title`
                    )}
                  </b>
                  :&nbsp;
                  {i18n.t(
                    `app_store_v2.app_integrations.desky.install_modal.alert.option_1.description`
                  )}
                </>
              )}
              {selectedOption === choiceValueTwo && (
                <>
                  <b>
                    {i18n.t(
                      `app_store_v2.app_integrations.desky.install_modal.alert.option_2.title`
                    )}
                  </b>
                  :&nbsp;
                  {i18n.t(
                    `app_store_v2.app_integrations.desky.install_modal.alert.option_2.description`
                  )}
                </>
              )}
            </Text.Normal>
          </Box>
        </Alert>
      </Box>
    </Modal>
  )
}

export default observer(ActivateDeskyInstallModal)
